import { Action } from 'redux'
import { ILicense } from '../../../models/License'
import { UserAccountActions } from '../../../reducers/userAccount/actionNames'

const requestLicense = (): IRequestLicense => ({
  type: UserAccountActions.RequestLicenseData,
})
const licenseAccepted = (license: ILicense[]): ILicenseAccepted => ({
  license,
  type: UserAccountActions.LicenseDataAccepted,
})
const licenseRejected = (err: string): ILicenseRejected => ({
  errMessage: err,
  type: UserAccountActions.LicenseDataRejected,
})

export { requestLicense, licenseAccepted, licenseRejected }
export type IRequestLicense = Action<UserAccountActions.RequestLicenseData>

export interface ILicenseAccepted
  extends Action<UserAccountActions.LicenseDataAccepted> {
  license: ILicense[]
}

export interface ILicenseRejected
  extends Action<UserAccountActions.LicenseDataRejected> {
  errMessage: string
}
